<template>
  <div>
    <!-- <v-responsive min-width="550"> -->
    <!--- START DIALOG --->
    <v-container 
      fluid
      pt-4
      mt-5
      mb-2
      pl-1
      pr-1>
      <v-layout row>
        <v-flex 
          class="text-xs-left"
 
          mb-3>
          <view-client-options :node-list="nodeList"/>
        </v-flex>
      </v-layout>
      <v-layout 
				row 
				wrap>
        <!-- START NEEDS RANKING -->
        <v-flex 
					xs12 
					sm12 
					md4 
					lg4 
					ml-1 
					mr-1
          mb-2>
          <v-card>
            <needs-ranking 
							v-if="nodeList" 
							:node-list="nodeList" 
							:client-name="clientName"/>
          </v-card>
        </v-flex>
        <v-spacer/>

        <!----- END NEEDS RANKING ---->

        <v-flex 
					xs12 
					sm12 
					md7 
					lg7
          ml-1
          mr-1
          mb-3>
          <v-card>
            <div ref="entireChart">
            <!---- START TOOLBAR --->
            <div id="header" >
            <v-toolbar 
							:color="strongColor" 
							flat 
							dark>
              <v-flex 
								offset-lg1>
                <v-toolbar-title
                  v-if="clientName !== null"
                  class="text-xs-center white--text"
                >
                  {{ clientName | fixName }}'s Reiss Profile®
                  </v-toolbar-title>
              </v-flex>
            </v-toolbar>
            <!-- END TOOLBAR --->
            </div>
            <v-layout row>
              <v-flex 
								xs8/>
            </v-layout>
            <v-flex 
							lg11 
							offset-lg1
              ml-1
              mr-1>
              <div 
                id="barchart">
              <vue-bar-chart
                v-if="allClientAttrs && needsRendered && nodeList"
                :client-name="clientName"
                :all-client-attrs="allClientAttrs"
              />
              </div>
            </v-flex>
            <div 
              v-if="windowWidth > 600"
              id="legend"
            >
            <v-layout 
							row 
							justify-space-between>
              <v-flex 
							xs2/>
              <v-layout 
								column>
                <v-flex 
								xs4 
								align-center 
								top>
                  <div>
                    <v-btn 
											:color="weakColor" 
											depressed 
											small/>
                  </div>
                  <div>Weak</div>
                  <div v-if="!scoresNotDisplayed">(Score of -2.00 to -0.84)</div>
                </v-flex>
              </v-layout>
              <v-layout 
								column>
                <v-flex 
									xs3>
                  <v-btn 
									:color="avgColor" 
									depressed 
									small/>
                  <div>Average</div>
                </v-flex>
              </v-layout>

              <v-layout column>
                <v-flex 
									xs3 
									lg3>
                  <v-btn 
										:color="strongColor" 
										depressed 
										small/>
                  <div>Strong</div>
                  <div v-if="!scoresNotDisplayed">(Score of +0.84 to +2.00)</div>
                </v-flex>
              </v-layout>
            </v-layout>
            <v-layout 
							row 
							justify-center 
							align-start>
              <v-flex 
								xs10 
								offset-xs2>
                <v-card-text class="legendLabel">Intensity of Desire</v-card-text>
              </v-flex>
            </v-layout>
            </div>
              </div>
            <v-card>
              <v-btn 
							:color="strongColor" 
              dark
							@click="downloadWithCSS(clientName)"  
              >Download PDF</v-btn>
            </v-card>
            <v-spacer/>

            <!--		<report 
				v-if="nodeList && clientName"
				:node-list="nodeList"
				:client-name="clientName" 
				:attr-list="checkedAttrs"
            />-->
          </v-card>
        
        </v-flex>
      </v-layout>
    </v-container>

    <!--<v-btn
  @click="downloadPDF">
    DLPDF</v-btn>-->
    <!-- </v-responsive> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import ClientMetadata from "./ClientMetadata";
import NeedsRanking from "./NeedsRanking";
import VueBarChart from "./VueBarChart";
import ViewClientOptions from "./ViewClientOptions";
import Report from "./Report";
import jsPDF from "jspdf";
//import Buffer from 'buffer'

import flatten from "flat";
import ClientsService from "@/services/ClientsService";
import EventBus from "@/main";
import {
  WEAK_COLOR,
  AVERAGE_COLOR,
  STRONG_COLOR,
  ATTR_MAP,
  addSign
} from "@/components/globals/consts";

import rmpTagline from "@/assets/rmp_acronym.png";
import { RMP_LOGO_SMALL } from "@/assets/rmp_logo";
//import html2canvas from 'html2canvas'

export default {
  components: {
    ClientMetadata,
    VueBarChart,
    NeedsRanking,
    ViewClientOptions,
    Report
  },
  data() {
    return {
      client: null,
      nodeList: null,
      clientName: null,
      needsRendered: false,
      allClientAttrs: null,
      menu: false,
      scoresNotDisplayed: true,
      weakColor: WEAK_COLOR,
      avgColor: AVERAGE_COLOR,
      strongColor: STRONG_COLOR,
      rmpLogoSmall: RMP_LOGO_SMALL,
      logoSrc: rmpTagline,
      str: null,
      barChart: null,
      windowWidth: 1200
    };
  },
  computed: {
    ...mapState(["isUserLoggedIn", "user", "route"]) //,
    //	checkedAttrs
  },
  async created() {
    if (!this.isUserLoggedIn) {
      this.$router.push({
        name: "login"
      });
    }
    try {
      const clientId = this.route.params.clientId;
      this.client = (await ClientsService.show(clientId)).data;
      
      // if (this.client === undefined) {
      //   console.log(this.client)
      // }
      
      let clientInfo = this.client;
      // console.log(`clientInof:${clientInfo}`)
      // console.log(typeof(this.client))
     if (clientInfo.name === undefined) {
       this.$router.push('/clients')
     }
      
      
      this.clientName = clientInfo.name;
      
      
      
      //console.log(typeof(this.clientName))


      this.allClientAttrs = clientInfo.ClientResult; //s['0']
      this.client = flatten(this.client);
      this.nodeList = [];
      for (let i in this.allClientAttrs) {
        let o = {};
        if (i.length === 3) {
          o.attr = ATTR_MAP[String(i)];
          if (this.allClientAttrs[i] != null) {
            o.value = addSign(+this.allClientAttrs[i]);
            this.nodeList.push(o);
          }
        }
      }
      await EventBus.$on("needsRendered", needsRendered => {
        if (needsRendered !== null) {
          this.needsRendered = needsRendered;
        }
      });
    } catch (e) {
      console.log(e);
    }
  },
  async mounted() {
  
    await EventBus.$on("toggleBarScores", value => {
      this.scoresNotDisplayed = value;
    });

    this.windowWidth = window.innerWidth

  },
  async beforeDestroy() {
    try {
      this.client = null;
      this.nodeList = null;
      this.allClientAttrs = null;
      this.pdf = null;
      this.canvasPDF = null;
      this.barChart = null;
      delete this.client;
      delete this.nodeList;
      delete this.allClientAttrs;
      delete this.canvasPDF;
      delete this.pdf;
      delete this.barChart;
      await this.$store.dispatch('setRenderClientList', false)

    } catch (err) {
      console.log(err);
    }
  },

  methods: {

async downloadWithCSS (clientName) {

  let doc = new jsPDF({orientation: 'p', unit: 'pt', format: 'letter'});
  
  console.log(this.$children)
  //let pdfImageHeight = 150 + 23*this.$data.nodeList.length 
  //let pdfImageHeight = 150 + 23*this.$parent.$.length 
  let pdfImageHeight = 600
  let currYear = new Date().getFullYear();
  let paperWidth = 612;
  let paperHeight = 792;
  
  let logoHeight = 70;
  let logoWidth = 120;
  let footerMargin = 36;
  let topMargin = 36;
  let leftMargin = 36;
  let rightMargin = 36;
  let centeredMargin = paperWidth / 2;
  let stdMargin = 36;
  
  doc.addImage(
    this.rmpLogoSmall,
    "PNG",
    topMargin,
    leftMargin,
    logoWidth,
    logoHeight
  );

  const el = this.$refs.entireChart
  const options = {
    type: 'dataURL'
  }
  let entireChartPNG = await this.$html2canvas(el, options)
  doc.addImage(
    entireChartPNG,
    'PNG',
    45,
    135,
    500,
    600
    )  

    doc.setFontSize(10);
    doc.text(
    `©2000-${currYear}. IDS Publishing Corporation. All rights reserved.`,
    paperWidth /2,
    paperHeight - footerMargin,
    "center")
    doc.save(`${clientName}'s Reiss Profile Chart.pdf`)
        
  }, // END downloadwithcss  
  }
};
</script>

<style scoped>
.legendLabel {
  font-size: 18px;
  font-weight: bold;
}
.onerow {
  display: inline-block;
}
.bsSpacer {
  color: white;
}

#desireLabel {
  font-size: 15px;
  padding: 10px 0px 0px 0 px;
  font-weight: bold;
  font-family: "Arial";
}
</style>



// WEBPACK FOOTER //
// src/components/ViewClient/ViewClientIndex.vue